const zh = {
    // Common
    'Close': '关闭',
    'From': '从',
    'To': '到',
    'Distance': '距离',
    'Estimated time': '预计时间',
    'Level': '楼层',
    'Search by name, category, building...': '按名称、类别、建筑物搜索...',
    'Show legend': '显示图例',
    'Ask with AI': '询问 AI',
    'Nothing was found': '未找到任何结果',
    'd': '天',
    'h': '小时',
    'min': '分钟',
    'Walk': '步行',
    'Bike': '骑车',
    'Transit': '公交',
    'Drive': '驾车',
    'Start wayfinding': '开始导航',
    // Location Details
    'Read full description': '查看完整描述',
    // Locations list
    'Locations': '位置',
    'Directions not available': '导航不可用',
    'Start directions': '开始导航',
    // Route instructions
    'Previous': '上一步',
    'Next': '下一步',
    'StepYofX': '第 {{activeStep}} 步，共 {{totalSteps}} 步',
    // Route Instructions Step
    'You have arrived': '您已到达',
    'Leave': '离开',
    'Park': '停车',
    'at': '在',
    'Building': '建筑',
    'Venue': '场所',
    'Take staircase to level': '走楼梯到',
    'Take the ladder to level': '走梯子到',
    'Take elevator to level': '乘电梯到',
    'Take escalator to level': '乘扶梯到',
    'Take wheelchair lift to level': '乘轮椅升降机到',
    'Take wheelchair ramp to level': '走轮椅坡道到',
    'Exit': '离开',
    'Enter': '进入',
    'stops': '站',
    'and continue': '然后继续',
    'Continue straight ahead': '直行',
    'Go left': '向左',
    'Go sharp left': '急转左',
    'Go slight left': '稍向左',
    'Go right': '向右',
    'Go sharp right': '急转右',
    'Go slight right': '稍向右',
    'Turn around': '掉头',
    // Wayfinding component
    'Switch': '切换',
    'Avoid stairs and escalators': '避开楼梯和扶梯',
    'Include bus transportation': '包含公交交通',
    'No route found': '未找到路线',
    'My position': '我的位置',
    'Go!': '出发！',
    'Directions': '导航',
    'Choose departure': '选择出发地',
    'Choose destination': '选择目的地',
    // Venue selector
    'Venues': '场所',
    'Select venue': '选择场所',
    'Current': '当前',
    // QR code dialog
    'Scan QR code': '扫描二维码',
    'Scan the QR code to see the route on your phone': '扫描二维码在手机上查看路线',
    'Done': '完成',
    // Directions
    'Cancel route': '取消路线',
    'Finish route': '完成路线',
    // Share location link
    'Share': '分享',
    'Copy link': '复制链接',
    'QR Code': '二维码',
    // Opening Hours
    'Open': '营业中',
    'Closed': '已关闭',
    'Expand opening hours': '展开营业时间',
    'Collapse opening hours': '收起营业时间',
    // View Selector
    'Go to view': '定位到',
    // Language Selector
    'Select language': '选择语言',
    // Accessibility
    'Increase text size to 200%': '将文本大小增加到 200%',
    'Decrease text size to 100%': '将文本大小减少到 100%',
    // Map Controls
    'Zoom in': '放大',
    'Zoom out': '缩小',
    // Ask with AI - Usage Consent
    'Usage consent title': 'Ask with AI - 使用须知',
    'Usage consent message': 'Ask with AI 利用人工智能（AI）帮助您查找地点并在此场所内导航。尽管我们力求准确，但 AI 有时可能会出错。请在出发前仔细核实重要信息。',
    'Usage consent accept': '我已了解',
    'Usage consent decline': '拒绝',
    'AI disclaimer': 'Ask with AI 可能会出错。请在出发前仔细核实重要信息。',
    // Location Consent
    'Location consent message': '为了提供个性化的路线指引并帮助您发现附近的地点，Ask with AI 需要访问您的位置信息。即使不提供位置信息，聊天功能仍然可用，但您需要手动指定起点。',
    'Location consent accept': '允许',
    'Location consent decline': '拒绝',
};

export default zh;